import {lenisScroll} from "./modules/lenis-scroll.js";

export const vars = {
    header: document.querySelector('.header'),
    bodySite: document.querySelector('body'),
    mobileMenu: document.querySelector('.mobile-menu'),
}